export const heartBeatFactors = {
    availabilty: [
        {
            item: 'tcu',
            index: 'TCU_DATA_AVAILABILITY',
            text: 'Telemetry',
            table: 'TELEMETRY'
        },
        {
            item: 'motor',
            index: 'MOTOR_DATA_AVAILABILITY',
            text: 'Motor',
            table: 'MOTOR'
        },
        {
            item: 'battery',
            index: 'BATTERY_DATA_AVAILABILITY',
            text: 'Battery',
            table: 'BATTERY'
        },
        {
            item: 'location',
            index: 'LOCATION_DATA_AVAILABILITY',
            text: 'Location',
            table: 'LOCATION'
        },
    ],
    range: [
        {
            field: 'ai_voltage_input',
            index: 'AI_VOLTAGE_IN_RANGE',
            text: 'AI Voltage',
            table: 'TELEMETRY'
        },
        {
            field: 'current',
            index: 'BATTERY_CURRENT_IN_RANGE',
            text: 'Battery Current',
            table: 'BATTERY'
        },
        {
            field: 'battery_volt',
            index: 'BATTERY_VOLTAGE_IN_RANGE',
            text: 'Battery Voltage',
            table: 'BATTERY'
        },
        {
            field: 'soc',
            index: 'LATEST_SOC',
            text: 'Battery SOC',
            table: 'BATTERY'
        }, 
    ],
    other: [
        {
            item: 'overall',
            index: 'OVERALL_DATA_AVAILABILITY',
            text: 'Overall Data',
        },
        {
            item: 'data_lag',
            index: 'DATA_LAG',
            text: 'Data Lag',
        },
    ],
    graphs: [
        {
            field: 'motor_dc_current',
            index: 'MOTOR_CURRENT_IN_RANGE',
            text: 'Motor Current',
            table: 'MOTOR',
            unit: 'A',
            show: true,
        },
        {
            field: 'ai_voltage_input',
            index: 'AI_VOLTAGE_IN_RANGE',
            text: 'AI Voltage',
            table: 'TELEMETRY',
            unit: 'V',
            show: false,
        },
        {
            field: 'motor_dc_voltage',
            index: 'MOTOR_VOLTAGE_IN_RANGE',
            text: 'Motor Voltage',
            table: 'MOTOR',
            unit: 'V',
            show: true,
        },
        {
            field: 'current',
            index: 'BATTERY_CURRENT_IN_RANGE',
            text: 'Battery Current',
            table: 'BATTERY',
            unit: 'A',
            show: false,
        },
        {
            field: 'battery_volt',
            index: 'BATTERY_VOLTAGE_IN_RANGE',
            text: 'Battery Voltage',
            table: 'BATTERY',
            unit: 'V',
            show: false,
        },
    ]
}
